<template>
  <div class="product container">
    <ul class="images">
      <li class="image__wrapper">
        <div class="picture__wrapper picture__wrapper--loading skeleton"></div>
      </li>
    </ul>

    <div class="content">
      <div class="product__details">
        <span class="product__title skeleton"></span>
        <div class="product__size skeleton"></div>
        <div class="product__button skeleton"></div>
        <div class="product__button skeleton"></div>
        <div class="product__text skeleton"></div>
        <div class="product__block skeleton"></div>
        <div class="product__block skeleton"></div>
        <div class="product__block skeleton"></div>
        <div class="product__block skeleton"></div>
        <div class="product__block skeleton"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/css/components/skeleton";

.product,
.container {
  @include respond-above(lg) {
    display: grid;
    grid-template-columns: 50% 50%;
    padding: 40px 40px 60px 40px !important;
  }
}

.product {
  &__title {
    display: inline-block;
    height: 40px;
    width: 200px;
    margin-bottom: 30px;
  }

  &__details {
    padding: 0px 20px 30px;
  }

  &__size {
    height: 128px;
    width: 100%;
    display: inline-block;
    margin-bottom: 10px;
  }

  &__button {
    height: 60px;
    width: 100%;
    display: inline-block;
    margin-top: 20px;
  }

  &__text {
    height: 200px;
    width: 100%;
    display: inline-block;
    margin: 10px;
  }

  &__block {
    height: 60px;
    width: 100%;
    display: inline-block;
    margin-bottom: 10px;
  }
}

.product.container {
  @include respond-below(md) {
    padding-left: 0;
    padding-right: 0;
  }
}

.content {
  @include respond-above(md) {
    position: sticky;
    top: 0;
    align-self: start;
  }
}

.picture__wrapper {
  display: inline-block;
  position: relative;
  width: 100%;

  &--loading {
    padding-bottom: 110%;
    width: 100%;
  }
}

.images {
  line-height: 0;
  overflow: hidden;
  white-space: nowrap;
  padding-bottom: 30px;

  @include respond-above(md) {
    padding-bottom: 0;
  }

  .image__wrapper {
    display: inline-block;
    width: 100%;

    @include respond-above(md) {
      display: block;
      margin-right: 0;
    }
  }
}
</style>
